import { FeatureFlag } from 'modules/featureFlags/types';

import { createEnabledFractionsForIds } from './createEnabledFractionsForIds';
import { createDisabledFractionsForIds } from './createDisabledFractionsForIds';

export const getOrgIdFractionsFromSettings = (settings: FeatureFlag['settings']) =>
  'orgIdFractions' in settings
    ? settings.orgIdFractions
    : {
        ...createEnabledFractionsForIds(settings.enabledOrgIds),
        ...createDisabledFractionsForIds(settings.disabledOrgIds),
      };
